export default __webpack_public_path__ + "static/media/EscudoRD.64ee1cd9.png";